<ems-confirm-message #confirmationMessage></ems-confirm-message>

<div class="heading-font sdps-p-bottom_small"
     [innerHTML]="getSharedConstant[businessUnit].step1IndicatorName"></div>

<div class="step-border-box sdps-p-around_large select-rule-type">
  <form [formGroup]="createEmpGrpRuleForm">
    <div class="sdps-grid-container sdps-wrap">
      <div class="sdps-row">
        <div class="rule-type-textbox col-3"
             [ngClass]="{'invalidField': ((createEmpGrpRuleForm.get('groupName').value && (createEmpGrpRuleForm.get('groupName').invalid) || groupNameExists))}">
          <p-floatlabel variant="in">
            <input id="step1GroupNameInput" *ngIf="this.businessUnit==='DBS'|| this.businessUnit==='SPS'" type="text" name="groupName" [maxlength]="100" formControlName="groupName"
                   #focusName emsAlphaNumericSpecialCharacterValidation emsCharacterLimit
                   [charMaxLimit]="commonConstants.charLimitValues.hundredMaxLimit"
                   (emsCharacterLimitCheck)="showGroupNameCharLimit = $event" pInputText/>
          <input id="step1PlanNameInput" *ngIf="this.businessUnit==='RBS' || this.businessUnit===this.getSharedConstant.manageMasterGroups.groupTypeMGP" type="text" name="groupName" [maxlength]="100" formControlName="groupName"
                   #focusName emsCharacterLimit
                   [charMaxLimit]="commonConstants.charLimitValues.hundredMaxLimit"
                   (emsCharacterLimitCheck)="showGroupNameCharLimit = $event" pInputText/>
            <label [for]="(this.businessUnit==='DBS'|| this.businessUnit==='SPS') ? 'step1GroupNameInput' : 'step1PlanNameInput'">{{getSharedConstant[businessUnit].name}}
              <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
            </label>
             </p-floatlabel>
        </div>
        @if(this.businessUnit===this.getSharedConstant.manageMasterGroups.groupTypeMGP && (manageEmpGrpService.showOBPCheckbox || this.formDataService.getFormData()?.subType === this.getSharedConstant.openBrokerage.subType)) {
        <div class="col-6 sdps-p-left_xx-large sdps-flex" >
          <div class="sdps-p-top_medium">
            <p-checkbox class="emtr-checkbox" inputId="openBrokeragePlan" formControlName="openBrokeragePlan"
             [ngClass]="{'p-disabled': isEditMode || toEnableOpenBrokeragePlan}" binary="true"></p-checkbox>
            <label for="openBrokeragePlan" [ngClass]="{'labelDisabled': isEditMode || toEnableOpenBrokeragePlan}" class="sdps-p-left_small">{{getSharedConstant.openBrokerage.openBrokeragePlanLbl}}</label>
          </div>
        </div>
        }
        <div class="col-6 sdps-p-left_xx-large sdps-flex" *ngIf="is10b5Client">
          <div class="sdps-p-top_medium">
            <p-checkbox class="emtr-checkbox" inputId="enable10b5Checkbox" formControlName="enable10b5Checkbox"
                        (onChange)="selected10b5()" [disabled]="isEditMode" binary="true"></p-checkbox>
                        <label for="enable10b5Checkbox" class="sdps-p-left_small">10b5-1</label>
          </div>
          <div class="sdps-display-inline-block sdps-m-left_xx-large rule-type-textbox"
               [ngClass]="{'invalidField': (createEmpGrpRuleForm.get('planId').value && (createEmpGrpRuleForm.get('planId').invalid)), 'input-disabled': isEditMode }"
               *ngIf="createEmpGrpRuleForm.get('enable10b5Checkbox').value">
            <p-floatlabel variant="in">
            <input id="planIdInput" type="number" onkeypress="return (event.which >= 48 && event.which <= 57 && this.value.length < 10)" [attr.disabled]="isEditMode ? true : null" name="planId" formControlName="planId" (blur)="removeLeadingZeroes()"
                   emsNumberPatterncheck pInputText />
            <label for="planIdInput">{{getConstant.manageEmployeeGroups.empGroup10b5Msg.planIdTxt}}
              <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
            </label>
            </p-floatlabel>
          </div>
        </div>
      </div>
      <p class="col-3 sdps-text-right sdps-p-around_none sdps-m-around_none sdps-text-small"
         *ngIf="createEmpGrpRuleForm.get('groupName').value && createEmpGrpRuleForm.get('groupName').value.trim().length > showGroupNameCharLimit">{{getConstant.rulesConstant.characterLimit}}
        <span class="character-limit">{{createEmpGrpRuleForm.get('groupName').value.trim().length}}
          /{{commonConstants.charLimitValues.hundredMaxLimit}}</span>
      </p>

      <div class="sdps-row sdps-p-top_large">
        <div class="rule-type-textbox sdps-p-around_medium col-6">
          <p-floatlabel variant="in">
            <textarea id="groupDescriptionTextarea" class="sdps-p-vertical_x-small group-desc" rows="5" maxlength="300" formControlName="description"
                      name="description" emsCharacterLimit (emsCharacterLimitCheck)="showGroupDescCharLimit = $event"
                      [charMaxLimit]="commonConstants.charLimitValues.threeHundredMaxLimit" pTextarea></textarea>
            <label for="groupDescriptionTextarea">{{getSharedConstant[businessUnit].description}}</label>
          </p-floatlabel>
        </div>
      </div>
      <p class="col-6 sdps-text-right sdps-p-around_none sdps-m-around_none sdps-text-small"
         *ngIf="createEmpGrpRuleForm.get('description').value && createEmpGrpRuleForm.get('description').value.length > showGroupDescCharLimit">{{getConstant.rulesConstant.characterLimit}}
        <span class="character-limit">{{createEmpGrpRuleForm.get('description').value.length}}
          /{{commonConstants.charLimitValues.threeHundredMaxLimit}}</span>
      </p>
    </div>
  </form>
</div>

<ems-step-wizard-buttons [disableBtn]="createEmpGrpRuleForm?(createEmpGrpRuleForm.invalid || groupNameExists || (createEmpGrpRuleForm.get('groupName').value && createEmpGrpRuleForm.get('groupName').value.trim() ==='')):''"
                         [showCancelBtn]=true (closeBtn)="cancelCreateEmpGroup()" [showContinueBtn]="true"
                         (goToNext)="goToNextStep()"></ems-step-wizard-buttons>
